/*jshint esversion: 6 */
// import store from '@/store/index';
import UltraRoute from '@/router/components/UltraRoute.js';
import WorkPackageEditorModule from '@/router/modules/WorkPackageEditor.module.js';

function Template(payload) {
  let route = UltraRoute({
    name: `${payload.location}WorkPackages`,
    path: 'workbench/:template_type/folder/:wfolder/workpackages',
    folder: 'WorkBenchRework',
    file: 'WorkBenchWorkPackages',
    auth:true,
    props: () => {
      return {
        location: payload.location
      };
    },
    children: [
      WorkPackageEditorModule({
        path: ':workpackage_id',
        location: payload.location,
        read_only: false,
        create: false,
        nav_back: `${payload.location}WorkPackages`,
      })
    ]
  });
  return route;
}
export default Template;
